import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';

import Carousel from '../../../shared-components/Carousel/Carousel';
const LOCALE_PREFIX = 'US/pages/LandingPage/LandingCarousel';

export class LandingCarousel extends Component {

    static propTypes = {
        currencySymbol: PropTypes.string,
        intl: intlShape.isRequired,
        currentPage: PropTypes.string,
        selectedIndex: PropTypes.number
    };

    static defaultProps = {
        selectedIndex: 1
    };

    render() {
        const {selectedIndex, intl, currencySymbol} = this.props;
        const pageName = 'landingpage';
        const specialFinancingTitle = (
            <FormattedHTMLMessage
                id={`${LOCALE_PREFIX}.specialFinancing`}
                values={{ currencySymbol: currencySymbol || '' }}
            />);
        const digitalCreditTitle = (
            <FormattedHTMLMessage id={`${LOCALE_PREFIX}.digitalCredit`} />
        );
        const LANDING_PAGE =
            [
                {
                    ICON: 'digitalCredit',
                    TITLE: digitalCreditTitle,
                    FOOTER : intl.formatMessage({id: `${LOCALE_PREFIX}.terms`})
                },
                {
                    ICON: 'specialFinancing',
                    TITLE: specialFinancingTitle,
                    FOOTER : intl.formatMessage({id: `${LOCALE_PREFIX}.terms`})
                },
                {
                    ICON : 'decisionInSeconds',
                    TITLE :  intl.formatMessage({id: `${LOCALE_PREFIX}.decisionInSeconds`}),
                    FOOTER : intl.formatMessage({id: `${LOCALE_PREFIX}.terms`})
                }
            ];
        return (
            <Carousel
                slides={LANDING_PAGE}
                selectedIndex={selectedIndex}
                currentPage={pageName}

            />
        );
    }
}

export const mapStateToProps = state => ({
    currencySymbol: _.get(state, 'serverData.currencySymbol')
});

export default connect(mapStateToProps)(injectIntl(LandingCarousel));
